<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>文章列表</span>
        <a v-if="listData.length > 0" class = "title_top_right_btn personal_add_btn rt" @click = "applyArticle">发布文章</a>
        <el-divider></el-divider>
      </p>
    </div>
    <div class="personal_live_list_search">
      <el-form :inline="true" :model="search" class="demo-form-inline" label-width="60px">
        <el-form-item label="时间">
           <el-date-picker
            v-model="search.year_month"
            type="month"
            placeholder="选择日期"
            value-format="yyyy-MM">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="板块">
          <el-cascader class="el-select"
          v-model = "search.model"
          :options="modelOptionsList"
          :props="modelProps"
          @change="modelChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="排序">
          <el-select v-model="search.sort" placeholder="请选择">
            <el-option label="最新" value="0"></el-option>
            <el-option label="最热" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
           <el-input
            placeholder="请输入关键词"
            suffix-icon="el-icon-search"
            v-model="search.title">
          </el-input>
        </el-form-item>
        <el-form-item class="personal_live_list_search_btn">
          <el-button type="primary" @click="searchSub()">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="personal_live_list_box"
    v-loading="listLoading"
    element-loading-text="列表加载中"
    element-loading-spinner="el-icon-loading">
      <div v-if="!listLoading" class="my_none">
        <img class="my_none_img" src="../../assets/img/user/articleListNone.png" alt="文章列表为空">
        <p class="my_none_user_text">
          <span>您暂且未发布任何文章！</span>
        </p>
        <button class = "personal_add_none_btn" @click.prevent = "applyArticle">发布文章</button>
      </div>
      <div v-else>
        <div v-for="(item) in listData" :key="item.id" class="personal_live_list_item">
          <div class="personal_live_list_head">
            <p class="personal_live_list_title lf" @click="allJump(3, item.list_id, item.nav_id)">
              {{item.article_title}}
            </p>
            <p class="personal_live_list_time rt">
              {{item.create_time}}
            </p>
          </div>
          <div class="personal_live_list_foot">
            <div class="personal_live_other lf">
             <span v-if="item.one_nav === '社区生态'" class="lf">{{item.one_nav}} - {{item.nav_name}}</span>
             <span v-else-if="item.union_name !== ''" class="lf">{{item.one_nav}} - {{item.union_name}} - {{item.nav_name}}</span>
             <span v-else-if="item.research_name !== ''" class="lf">{{item.one_nav}} - {{item.research_name}} - {{item.nav_name}}</span>
             <el-divider direction="vertical" v-if="item.post_status === 1"></el-divider>
              <el-breadcrumb v-if="item.post_status === 1" separator="·">
                <el-breadcrumb-item>阅读量 {{item.read}}</el-breadcrumb-item>
                <el-breadcrumb-item>点赞 {{item.post_like}}</el-breadcrumb-item>
                <el-breadcrumb-item>评论 {{item.comment_count}}</el-breadcrumb-item>
                <el-breadcrumb-item>收藏 {{item.post_favorites}}</el-breadcrumb-item>
                <!-- <el-breadcrumb-item>分享 {{item.share}}</el-breadcrumb-item> -->
              </el-breadcrumb>
            </div>
            <div class="personal_live_btn rt">
              <div class="lf" v-if="item.post_status === 0">
                <el-popover
                  content="正在审核中,请耐心等待..."
                  trigger="click"
                >
                  <span slot="reference">审核中</span>
                </el-popover>
              </div>
              <div class="lf" v-if="item.post_status === 2">
                <el-popover
                  content="拒绝原因"
                  trigger="click"
                >
                  <span slot="reference">审核拒绝</span>
                </el-popover>
              </div>
              <el-divider direction="vertical" v-if="item.post_status === 0 || item.post_status === 2"></el-divider>
              <span class="personal_live_btn_text" @click.stop="detail(item.list_id, item.nav_id)">查看</span>
              <el-divider direction="vertical" v-if="item.post_status === 1 || item.post_status === 2"></el-divider>
              <span class="personal_live_btn_text" v-if="item.post_status === 1 || item.post_status === 2" @click="edit(item.article_id)">编辑</span>
              <el-divider direction="vertical" v-if="item.post_status === 1 || item.post_status === 2"></el-divider>
              <el-popconfirm
                title="确定删除改文章？"
                @onConfirm="del(item.article_id)"
              >
              <span class="personal_live_btn_text" v-if="item.post_status === 1 || item.post_status === 2" slot="reference">删除</span>
              </el-popconfirm>
            </div>
          </div>
        </div>
        <el-pagination
          v-if="listData.length > 0 && listType === 'all'"
          background
          layout="prev, pager, next"
          :page-size= "listLimit"
          :total="listNum"
          @current-change = "pageChange">
        </el-pagination>
        <el-pagination
          v-if="listData.length > 0 && listType === 'search'"
          background
          layout="prev, pager, next"
          :page-size= "search.limit"
          :total="listNum"
          @current-change = "pageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      listData: [], // 文章列表
      listNum: 0, // 文章总条目
      listLimit: 10, // 列表当前页显示条目数
      listPage: 1, // 列表当前页码
      listLoading: true, // 开启加载动画
      listType: 'all', // 列表显示类型
      search: { // 搜索参数
        year_month: '', // 时间
        model: '', // 所属模块绑定数组
        nav_id: '', // 所属板块
        title: '', // 搜索文本
        union_id: '', // 联盟id
        research_id: '', // 研究院id
        limit: 10, // 分页
        page: 1 // 页码
      },
      modelProps: { // 板块选择器配置
        value: 'id',
        label: 'name',
        children: 'child'
      },
      modelOptionsList: [] // 板块选择数组
    }
  },
  created () {
    this.pageChange()
    this.getModel()
  },
  methods: {
    // 获取选择模块
    getModel () {
      const vueThat = this
      const typeId = 3
      vueThat.myApi.getModel({ type_id: typeId }).then(function (res) {
        console.log(res)
        if (res.data.code === 200) {
          const navList = res.data.data.nav_list
          const unionList = res.data.data.union_list
          const researchList = res.data.data.research_list
          for (let i = 0; i < navList.length; i++) {
            const model = navList[i].model
            for (let n = 0; n < model.length; n++) {
              const sonModel = model[n].model
              if (sonModel !== undefined && sonModel.length > 0) {
                for (let m = 0; m < sonModel.length; m++) {
                  if (sonModel[m].is_use === 0) {
                    sonModel[m].disabled = true
                  }
                }
              } else {
                if (model[n].is_use === 0) {
                  model[n].disabled = true
                }
              }
            }
          }
          if (unionList.length > 0 && navList[1].model.length > 0) {
            for (let i = 0; i < unionList.length; i++) {
              unionList[i].model = navList[1].model
            }
            navList[1].model = unionList
          } else {
            navList[1].disabled = true
          }
          if (researchList.length > 0 && navList[2].model.length > 0) {
            for (let i = 0; i < researchList.length; i++) {
              researchList[i].model = navList[2].model
            }
            navList[2].model = researchList
          } else {
            navList[2].disabled = true
          }
          for (let i = 0; i < navList.length; i++) {
            navList[i].child = navList[i].model
          }
          console.log(navList)
          vueThat.modelOptionsList = navList
        }
      })
    },
    // 模块选定后的回调
    modelChange (value) {
      if (value[0] === 3) {
        this.search.nav_id = 0
        this.search.union_id = value[1]
        this.search.research_id = 0
      } else if (value[0] === 4) {
        this.search.nav_id = 0
        this.search.union_id = 0
        this.search.research_id = value[1]
      } else {
        this.search.nav_id = value[1]
        this.search.union_id = 0
        this.search.research_id = 0
      }
    },
    // 查询提交
    searchSub () {
      this.listType = 'search'
      this.pageChange()
    },
    // 发布文章
    applyArticle () {
      const routeData = this.$router.resolve({
        path: '/articleApply'
      })
      window.open(routeData.href, '_blank')
    },
    // 修改编辑
    edit (id) {
      const routeData = this.$router.resolve({
        path: '/articleApply',
        query: { id: id, type: 'article' }
      })
      window.open(routeData.href, '_blank')
    },
    // 查看
    allJump: function (type, id, navId) {
      this.mycommon.allJump(this, type, id, navId)
    },
    // 删除
    del: function (id) {
      const vueThat = this
      this.myApi.articleDel({ article_id: id }).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          vueThat.$alert('文章删除成功！', '温馨提示', {
            type: 'success',
            iconClass: 'iconfont icon-icon_richeng_btn_pass',
            confirmButtonText: '确定',
            showClose: false,
            callback: action => {
              vueThat.loading = true
              vueThat.pageChange()
            }
          })
        }
      })
    },
    // 获取数据
    pageChange: function (index) {
      const vueThat = this
      if (index === undefined) {
        vueThat.listPage = 1
        vueThat.search.page = 1
      } else {
        vueThat.listPage = index
        vueThat.search.page = index
      }
      let data = {}
      if (this.listType === 'search') {
        data = vueThat.search
      } else {
        data = {
          limit: vueThat.listLimit,
          page: vueThat.listPage
        }
      }
      vueThat.myApi.articleAdminList(data).then(function (res) {
        if (res.data.code === 200) {
          vueThat.listLoading = false
          vueThat.listData = res.data.data.data
          vueThat.listNum = res.data.data.count
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
  .personal_live_list_box{
    min-height: 500px;
  }
</style>
